module.exports = __webpack_public_path__ + "static/6-0804e935fbfac2f475b5c03dd3a8094d.jpg";